import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default FontAwesomeIcon;
